import { Badge } from '@/components/ui/Badge';
import { PIPELINE_LABELS, type PipelineStage } from '@/types/clients';

const STAGE_TONES: Record<PipelineStage, 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brass'> = {
  lead:        'neutral',
  qualified:   'info',
  specified:   'brass',
  quoted:      'brass',
  awarded:     'success',
  closed_won:  'success',
  closed_lost: 'danger',
  dormant:     'neutral',
};

export function StageBadge({ stage }: { stage: PipelineStage }) {
  return <Badge tone={STAGE_TONES[stage]}>{PIPELINE_LABELS[stage]}</Badge>;
}
